<template>
    <div class="user">
        <div class="nav">
            <img
                class="navBack pull-left"
                src="../../../static/images/common/newBack.png"
                alt
                @click="goUrl()"
            />
            用户协议
        </div>
        <div class="userman">
            <div class="title center">服务声明</div>
            <p class="title">租铺宝服务声明</p>
            <p>隐私权是用户的重要权利，对于租铺宝的所有用户，我们均会以负责的态度对待您的 个人信息，特此制定租铺宝（http://wwwyoupuchina.com，以下称"本网站"）对用户相关信息所采取的收集、使用和保护政策。 租铺宝隐私保护声明系本网站保护用户个人隐私的公告和承诺，请您务必仔细阅读。</p>
            <p class="title">一、用户非个人信息</p>
            <p>我们将通过您的IP地址来收集非个人化的信息，例如用户的浏览器性质、操作系统 种类、给您提供接入服务的ISP域名、您访问本网的顺序和链接途径、您访问时所在的地理位置等。通过收集上述信息，我们将优化在您计算机屏幕上显示的页面，同时进行客流量统计、访问者阅读习惯整理等，从而改进本网站的管理和服务。 这些无关个人身份的信息能帮助我们识别租铺宝最受欢迎的功能和内容等，并帮助我们确定推广活动的有效性。此外，我们也可能将这些信息披露给我们的客户，使他们知道点击他们信息的效果数据。</p>
            <p class="title">二、用户个人信息</p>
            <p>1、当您在租铺宝进行注册并发布需求时、本网站将通过发布表格等形式要求您提供一些个人信息。这些个人信息包括：</p>
            <p>（1）个人资料：如姓名、手机、地址等信息。</p>
            <p>（2）商铺信息：商铺区域、经营业态、租金、转让费等</p>
            <p>2、请了解，在未经您同意并确认之前，本网站不会将您提供的信息用于其它目的。惟按下列第八章规定应政府及法律相关要求披露时不在此限。 租铺宝的目标是为客户提供卓越的服务，让租铺变轻松，而收集这些个人信息有助于我们实现这一目标。 所有的注册用户和访问用户都应该知道，当他们在其他网上公开场合披露其个人信息时，该信息可能会被他人收集并使用，包括用来向该用户发送未经邀约的电子邮件等广告信息。</p>
            <p class="title">三、用户权利</p>
            <p>1、本网站用户对于自己的个人信息享有以下权利：</p>
            <p>(1)随时查询及请求阅览;</p>
            <p>(2)随时请求补充或更正;</p>
            <p>(3)随时请求删除;</p>
            <p>(4)请求停止电脑处理及使用。</p>
            <p>2、本网站为用户提供各种专享服务，如委托选址、委托转铺、开通会员等各项活动，是否参加此类活动，这完全取决于用户自身。</p>
            <p>3、针对以上权利，本网站为您提供相关服务，如用户有任何建议或意见，请发送电子邮件至youpuchina@126.com。</p>
            <p class="title">四、用户信息安全保护</p>
            <p>1、 本网站将严格保护您的个人信息安全，对您所提供的信息采取严密的管理及保护措施。我们将采用相应的安全技术和程序来防止您的个人信息丢失、被盗用或遭篡改，并且保护您的个人信息不被未经授权者访问、使用或泄漏</p>
            <p>2、本网站将在必要时委托专业技术人员代为对该类资料进行电脑处理，以符合专业分工之需求。如本网站将电脑处理之通知送达予您，而您未在通知规定的时间内主动明示反对，本网站将善意推定您已同意。此后您仍然有权按照上述第三章第1条第（4）款之规定，请求停止电脑处理。</p>
            <p class="title">五、用户隐私自我保护</p>
            <p>1、租铺宝为您提供发布求租、发布出租、发布转让等服务，并善意提醒所有用户，该区域为网络公开场合，在这些区域内，您公布的任何信息都有可能成为公开的信息。因此，本网提醒您，在这些区域公开您的个人信息之前请慎重考虑。</p>
            <p>2、用户是唯一对自己的账号密码及其相关注册信息负有权限及保密责任的人。因此，当你在线时，请务必小心保护自己的账户安全。</p>
            <p class="title">六、未成年人隐私权的保护</p>
            <p>1、本网站将建立相应合理程序，以保护未成年人个人信息的安全。本网站郑重声明：任何十六岁以下的未成年人参加网上活动应事先得到家长或其法定监护人（以下统称为“监护人”）的明确同意。</p>
            <p>2、未经监护人同意，未成年人私自上网或者冒用成人名义上网的行为将可能缺乏与未成年人相应的信息安全保护措施。</p>
            <p>3、监护人应承担保护未成年人相关网络隐私的首要责任。</p>
            <p>4、本网站收集未成年人的个人信息，仅为更好服务于未成人特定要求的目的，相关资料仅作为保护未成年人参与网络活动时的安全之用，而不会保留这些信息做进一步或其他商业目的的使用。</p>
            <p>5、未经监护人同意，本网站将不会使用未成年人的个人信息，亦不会向任何第三方披露或传送可识别该未成人的个人信息。惟按上述第六章规定应政府及法律相关要求披露时不在此限。</p>
            <p>6、若经未成年人的监护人同意，本网站可对未成年人的个人信息进行收集，本网站将向监护人提供：</p>
            <p>(1)审视其子女或被监护人相关信息的机会；</p>
            <p>(2)拒绝其子女或被监护人相关个人信息被进一步收集或使用的可能；</p>
            <p>(3)变更或删除其子女或被监护人个人信息。</p>
            <p>7、监护人有权拒绝本网站与其子女或被监护人做进一步的联络。</p>
            <p class="title">七、用户信息使用原则 惟在符合下列条件之一的情况下，本网站方可能对本网用户的个人信息进行必要范围之外的合理使用：</p>
            <p>1、已取得您的书面同意；</p>
            <p>2、为免除您在生命、身体或财产方面的紧急危险；</p>
            <p>3、为防止他人权益的重大危害；</p>
            <p>4、为增进公共利益，且无害于您的重大利益。</p>
            <p class="title"> 八、用户信息披露原则</p>
            <p> 1、根据中华人民共和国相关法律法规，当相关政府机关依照法定程序要求本网站披露相关个人信息时，本网站将根据执法单位之要求或为公共安全之目的提供相关资料。在此情况下对用户信息的任何披露，本网站均不承担任何责任。</p>
            <p> 2、其他租铺宝因善意确信或合理原因有必要对相关用户信息进行披露的情形：</p>
            <p> (1)根据租铺宝服务协议或租铺宝其他相关声明所列的条款，有必要进行相关信息公开的；</p>
            <p> (2)在紧急的情况下，为保护租铺宝公司及租铺宝用户的人身或财产安全的；</p>
            <p> (3)为体现公平公正原则，需要对用户的部分需求进行公示的。</p>
            <p class="title"> 九、Cookies</p>
            <p> 1、Cookies是指一种技术，当使用者访问设有Cookies装置的本网站时，本网站的服务器会自动发送Cookies至用户浏览器内，并储存到其电脑硬盘内。此Cookies负责记录日后您到访本网站的种种活动、网络个人资料、浏览习惯等。</p>
            <p> 2、租铺宝使用cookies仅为为所有用户提供更加周到的服务之目的。运用Cookies技术，本网站能够知道哪些网页或内容受欢迎。此外，本网站将会运用Cookies追访您的喜好，使您在访问我们的网站时能够得到更周密更细致的良好服务。</p>
            <p> 3、cookies不会跟踪个人信息。当您注册成为我们网站用户时，租铺宝会使用cookies。在这种情况下，会存储有用信息，使您再次访问我们的网站时可辨认您的身份，从而向您提供感兴趣的信息资料或储存账号密码等，以便您造访本网站时不必每次重复登</p>录。
            <p> 4、来自租铺宝的cookies只能被租铺宝读取。您可以选择接受或拒绝 Cookie。大多数网络浏览器会自动接受 Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。如果您的浏览器被设置为拒绝cookies，您仍然能够访问我们的大多数网</p>页，<p> 但是您可能无法完全体验租铺宝全部的网络服务或本网站的特色 互动功能。</p>
            <p class="title"> 十、免责 除上述第八章规定的免责情形外，下列情况本网站亦毋需承担任何责任：</p>
            <p> 1、由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息泄露，或其他非因租铺宝原因导致的个人信息泄漏；</p>
            <p> 2、任何由于黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之非租铺宝原因而造成的个人信息泄露、丢失、被盗用或被篡改等；</p>
            <p> 3、租铺宝的网页上有与其他网站网页的链接。租铺宝对其他任何网站的内容、隐私政策、运营情况、或经营这些网站的公司的行为概不负责。在向这些与租铺宝链接的网站提供个人信息之前，请查阅它们的隐私政策。由于与本网站链接的其它网站所造成的个人信息泄露及由此而导致的任何法 </p>
            <p> 4、任何因不可抗力所导致的后果。</p>
            <p class="title"> 十一、相关法律</p>
            <p> 本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。</p>
            <p class="title"> 十二、本网站相关声明版权及其修改权、更新权和最终解释权均属租铺宝所有。</p>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "userAgreement",
  data() {
    return {};
  },
  computed: {},
  methods: {
    goUrl() {
      this.$router.go(-1);
    }
  },
  mounted() {
    let move = getUrlId("move");

    if (move == "android") {
      $(".nav").hide();
    }
  }
};
</script>
<style scoped lang="scss"  type="text/scss">
.user {
  .nav {
    width: 7.5rem;
    height: 1.2rem;
    background: white;
    position: relative;
    text-align: center;
    font-size: 0.34rem;
    font-weight: bold;
    line-height: 1.2rem;
    color: #363636;
    border-bottom: 0.01rem solid #e5e5e5;
    img {
      width: 0.37rem;
      height: 0.37rem;
      top: 0.4rem;
      position: absolute;
      left: 0.25rem;
      float: left;
    }
  }
  background: #ffffff;
  font-size: 0.28rem;
  .userman {
    padding: 0 0.3rem .6rem;
    box-sizing: border-box;
    padding-top: 0.2rem;
    line-height: .6rem;
    .title {
      font-size: 0.3rem;
      color: #333;
    }
    .bold {
      font-weight: bold;
      color: #333;
    }
    .center {
      text-align: center;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/login/userAgreement.vue